import React from 'react';
import type { ScheduleDataContext } from '../core/ScheduleDataContext';
import { Modal, ModalBody } from '../ui/index';
import type { ModalProps } from '../ui/Modal/Modal';
import OpenPositionForm from './OpenPositionForm';
import type { OpenPositionsFragment } from '../../graphql';

type OpenPositionModalContentProps = {
  vesselId?: number;
  onClose: () => void;
  initialStartTime?: number;
  openPosition?: OpenPositionsFragment;
  scheduleContext?: ScheduleDataContext;
  lastItemEnd?: number;
  lastPortId?: number;
};

export type OpenPositionModalProps = OpenPositionModalContentProps &
  Partial<ModalProps>;

const OpenPositionModal = (
  props: OpenPositionModalProps,
): JSX.Element | null => {
  const {
    onClose,
    vesselId,
    openPosition,
    scheduleContext,
    lastItemEnd,
    lastPortId,
    ...restProps
  } = props;
  if (vesselId === undefined || scheduleContext === undefined) {
    return null;
  }

  return (
    <Modal isOpen onClose={onClose} {...restProps} height="30em" width="30em">
      <ModalBody p={0} overflowX="visible" overflowY="visible">
        <OpenPositionForm
          onClose={onClose}
          vesselId={vesselId}
          openPosition={openPosition}
          scheduleContext={scheduleContext}
          lastItemEnd={lastItemEnd}
          lastPortId={lastPortId}
        />
      </ModalBody>
    </Modal>
  );
};

export default OpenPositionModal;
